import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { AuthGuard } from './helpers/auth.guard';
import { VerificationComponent } from './components/verification/verification.component';
import { FaqComponent } from './components/faq/faq.component';
import { WhyGovtTowAuctionComponent } from './components/whygovttowauction/whygovttowauction.component';
import { PrivacypolicyComponent } from './components/privacypolicy/privacypolicy.component';
import { TncComponent } from './components/tnc/tnc.component';
import { AuctionSchedulerComponent } from './components/auction-scheduler/auction-scheduler.component';
import { RemovebidderaccountComponent } from './components/removebidderaccount/removebidderaccount.component';
const routes: Routes = [
  {
    path: 'login',  loadChildren: () => import('./components/login/login.module').then(m => m.LoginModule),

    data: {
      title: 'GovTow Auction - Login'
    }
  },
  {
    path: 'sellerlogin', loadChildren: () => import('./components/sellerlogin/seller-login.module').then(m => m.SellerLoginModule),
    data: {
      title: 'GovTow Auction - Seller Login'
    }
  },
  {
    path: 'home', component: HomeComponent,
    data: {
      title: 'GovTow Auction - Home'
    }
  },
  { path: '',   /* canActivate: [AuthGuard], */redirectTo: '/home', pathMatch: 'full' }, //, canActivate: [AuthGuard]
  {
    path: 'register', loadChildren: () => import('./components/biddersignup/biddersignup.module').then(m => m.BiddersignupModule),
    data: {
      title: 'GovTow Auction - Register'
    }
  },
  {
    path: 'editprofile', loadChildren: () => import('./components/signup/signup.module').then(m => m.SignupModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - My Profile'
    }
  },
  {
    path: 'contactus', loadChildren: () => import('./components/contactus/contactus.module').then(m => m.ContactusModule),
    // canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Contact Us'
    }
  },
  {
    path: 'aboutus', loadChildren: () => import('./components/aboutus/aboutus.module').then(m => m.AboutusModule),
    data: {
      title: 'GovTow Auction - About Us'
    }
  },
  {
    path: 'home', loadChildren: () => import('./components/home/home.module').then(m => m.HomeModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Home'
    }
  },
  { path: 'customers',  canActivate: [AuthGuard], loadChildren: () => import('./components/customers/customers.module').then(m => m.CustomersModule) },
  { path: 'vehiclelist',  canActivate: [AuthGuard], loadChildren: () => import('./components/vehiclelist/vehiclelist.module').then(m => m.VehiclelistModule) },
  { path: 'pastauction',  canActivate: [AuthGuard], loadChildren: () => import('./components/pastauction/pastauction.module').then(m => m.PastauctionModule) },
  { path: 'logout',  canActivate: [AuthGuard], loadChildren: () => import('./components/logout/logout.module').then(m => m.LogoutModule) },
  {
    path: 'changepassword', loadChildren: () => import('./components/changepassword/changepassword.module').then(m => m.ChangepasswordModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Change Password'
    }
  },
  {
    path: 'forgotpassword', loadChildren: () => import('./components/forgotpassword/forgotpassword.module').then(m => m.ForgotpasswordModule),
    data: {
      title: 'GovTow Auction - Forgot Password'
    }
  },
  {
    path: 'resetpassword', loadChildren: () => import('./components/resetpassword/resetpassword.module').then(m => m.ResetpasswordModule),
    data: {
      title: 'GovTow Auction - Reset Password'
    }
  },
  {
    path: 'bidderhistory', loadChildren: () => import('./components/bidderhistory/bidderhistory.module').then(m => m.BidderhistoryModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Bid History'
    }
  },
  {
    path: 'seller/bidhistory', loadChildren: () => import('./components/sellerbidhistory/sellerbidhistory.module').then(m => m.SellerbidhistoryModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Seller Bid History'
    }
  },
  { path: 'auctionlist',  canActivate: [AuthGuard], loadChildren: () => import('./components/auctionlist/auctionlist.module').then(m => m.AuctionlistModule) },
  { path: 'searchdetails', loadChildren: () => import('./components/searchdetails/searchdetails.module').then(m => m.SearchdetailsModule) },
  { 
    path: 'list/iframe', 
    loadChildren: () => import('./components/sellereditbidder/sellereditbidder.module').then(m => m.SellereditbidderModule),
    data: {
      title: 'GovTow Auction - Edit Bidder Profile'
    }
  },
  { 
    path: 'seller/currentbids/iframe', 
    loadChildren: () => import('./components/sellercurrentbids/sellercurrentbids.module').then(m => m.SellercurrentbidsModule),
    data: {
      title: 'GovTow Auction - Seller Current Bids'
    }
  },
  { 
    path: 'seller/bidhistory/iframe', 
    loadChildren: () => import('./components/sellerbidhistory/sellerbidhistory.module').then(m => m.SellerbidhistoryModule),
    data: {
      title: 'GovTow Auction - Seller Bid History'
    }
  },
  {
    path: 'vehicledetails', loadChildren: () => import('./components/vehicledetails/vehicledetails.module').then(m => m.VehicledetailsModule),
    data: {
      title: 'GovTow Auction - Vehicle Details'
    }
  },
  {
    path: 'bidderdashboard', loadChildren: () => import('./components/bidderdashboard/bidderdashboard.module').then(m => m.BidderdashboardModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Dashboard'
    }
  },
  {
    path: 'enterprisedashboard', loadChildren: () => import('./components/enterprisedashboard/enterprisedashboard.module').then(m => m.EnterprisedashboardModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Dashboard'
    }
  },
  {
    path: 'bidderwonunpaid', loadChildren: () => import('./components/bidderwonunpaid/bidderwonunpaid.module').then(m => m.BidderwonunpaidModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Won Unpaid'
    }
  },
  {
    path: 'sellerconfig', loadChildren: () => import('./components/sellerconfig/sellerconfig.module').then(m => m.SellerconfigModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Config'
    }
  },
  {
    path: 'multibidvehicles', loadChildren: () => import('./components/multibidvehicles/multibidvehicles.module').then(m => m.MultibidvehiclesModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Current Bids'
    }
  },
  {
    path: 'seller/currentbids', loadChildren: () => import('./components/sellercurrentbids/sellercurrentbids.module').then(m => m.SellercurrentbidsModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Seller Current Bids'
    }
  },
  {
    path: 'seller/editbidder', loadChildren: () => import('./components/sellereditbidder/sellereditbidder.module').then(m => m.SellereditbidderModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Edit Bidder Profile'
    }
  },
  {
    path: 'unsoldvehicles', loadChildren: () => import('./components/unsoldvehicles/unsoldvehicles.module').then(m => m.UnsoldvehiclesModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Unsold Vehicles'
    }
  },
  // { path: 'addvehicle', loadChildren: () => import('./components/addvehicle/addvehicle.module').then(m => m.AddvehicleModule) },
  {
    path: 'auctiondateconfig', loadChildren: () => import('./components/auctiondateconfig/auctiondateconfig.module').then(m => m.AuctiondateconfigModule),
    // canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Auction Date Config'
    }
  },
  {
    path: 'paymentprofile', loadChildren: () => import('./components/paymentprofile/paymentprofile.module').then(m => m.PaymentprofileModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Payment Profile'
    }
  },
  {
    path: 'notification', loadChildren: () => import('./components/notification-settings/notification-settings.module').then(m => m.NotificationSettingsModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Notification Settings'
    }
  },
  {
    path: 'verification', component: VerificationComponent,    
    data: {
      title: 'GovTow Auction - Verification'
    }
  },
  {
    path: 'faq', component: FaqComponent,
    // canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Faq'
    }
  },
  {
    path: 'whygovttowauctions', component: WhyGovtTowAuctionComponent,
    // canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Why GovTow Auctions'
    }
  },
  {
    path: 'privacypolicy', component: PrivacypolicyComponent,
    // canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Privacy Policy'
    }
  },
  {
    path: 'tnc', component: TncComponent,
    // canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Terms of Use'
    }
  },
  {
    // Rollback reference: path: 'admin', loadChildren: () => import('../../admin/src/app/user/admin.module').then(m => m.AdminModule),
    // The live route now points at the copied feature inside the main app.
    path: 'admin', loadChildren: () => import('./migrated-admin/user/admin.module').then(m => m.AdminModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Add new user'
    }
  },
  { path: 'home2',  canActivate: [AuthGuard], loadChildren: () => import('./components/home2/home2.module').then(m => m.Home2Module) },

  { path: 'allauctions', loadChildren: () => import('./components/allauctions/allauctions.module').then(m => m.AllauctionsModule) },
  { path: 'ourfeatures',  canActivate: [AuthGuard], loadChildren: () => import('./components/ourfeatures/ourfeatures.module').then(m => m.OurfeaturesModule) },
  { path: 'bidderapprovalrequest',  canActivate: [AuthGuard], loadChildren: () => import('./components/bidderapprovalrequest/bidderapprovalrequest.module').then(m => m.BidderapprovalrequestModule) },
  {
    path: 'hpdbiddereditprofile', loadChildren: () => import('./components/hpdbiddereditprofile/hpdbiddereditprofile.module').then(m => m.HpdbiddereditprofileModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - My Houston Police Department Profile'
    }
  },
  {
    path: 'hcsobiddereditprofile', loadChildren: () => import('./components/hcsobiddereditprofile/hcsobiddereditprofile.module').then(m => m.HcsobiddereditprofileModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - My Harris County Sheriff Office Profile'
    }
  },
  {
    path: 'mkebiddereditprofile', loadChildren: () => import('./components/mkebiddereditprofile/mkebiddereditprofile.module').then(m => m.MkebiddereditprofileModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - My City Of Milwaukee Profile'
    }
  },
  {
    path: 'auctionscheduler', component: AuctionSchedulerComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Auction Scheduler Calendar'
    }
  },
  {
    path: 'uridashboard', loadChildren: () => import('./components/uridashboard/uridashboard.module').then(m => m.UridashboardModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Dashboard'
    }
  },{
    path: 'endedauctionsummary', loadChildren: () => import('./components/endedauctionsummary/endedauctionsummary.module').then(m => m.EndedauctionsummaryModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Ended Auction Summary'
    }
  },
  {
    path: 'latestauctions', loadChildren: () => import('./components/latestauctions/latestauctions.module').then(m => m.LatestauctionsModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Latest Auctions'
    }
  },
  {
    path: 'currentauctions', loadChildren: () => import('./components/currentauctions/currentauctions.module').then(m => m.CurrentauctionsModule),
    data: {
      title: 'GovTow Auction - Current Auctions'
    }
  },
  {
    path: 'upcomingauctions', loadChildren: () => import('./components/upcomingauctions/upcomingauctions.module').then(m => m.UpcomingauctionsModule),
    data: {
      title: 'GovTow Auction - Upcoming Auctions'
    }
    },
    {
    path: 'upcomingauctionsbyseller/:id', loadChildren: () => import('./components/upcomingauctionsbyseller/upcomingauctionsbyseller.module').then(m => m.UpcomingauctionsBySellerModule),
    data: {
      title: 'GovTow Auction - Upcoming Auctions'
    }
  },
  {
    path: 'removebidderaccount', component: RemovebidderaccountComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Remove Your Acount'
    }
  },
  {
    path: 'bidderinvoices', loadChildren: () => import('./components/bidderinvoices/bidderinvoices.module').then(m => m.BidderinvoicesModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Bidder Invoices'
    }
  },
  {
    path: 'bidderlist', loadChildren: () => import('./components/bidderlist/bidderlist.module').then(m => m.BidderlistModule),
    canActivate: [AuthGuard],
    data: {
      title: 'GovTow Auction - Bidder List'
    }
  },
  // {
  //   path: 'latestauctions', component: LatestauctionsComponent,
  //   data: {
  //     title: 'GovTow Auction - Latest Auctions'
  //   }
  // }, 
  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
